import { useNavigate, useParams } from "react-router-dom";
import InputForm from "../../componentes/input/input";
import { useState } from "react";
import UsuarioService from "../../services/resource/usuarioService";
import LOGO from '../../assets/logo.png'
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";


function RedefinirSenha() {
    const navigate      = useNavigate();
    const service       = new UsuarioService();
    const { email }     = useParams();

    const [codigo,       setCodigo]       = useState("");
    const [senha,        setSenha]        = useState("");
    const [confirmacao,  setConfirmacao]  = useState("");
    const [showSenha,    setShowSenha]    = useState(false);
    const [showConf,     setShowConf]     = useState(false);
    const [loading,      setLoading]      = useState(false);
    const [erro,         setErro]         = useState("");
    const [codigoInvalidado, setCodigoInvalidado] = useState(false);

    const redefinir = (e) => {
        e.preventDefault();
        setErro("");
        setCodigoInvalidado(false);

        if (senha !== confirmacao) { setErro("As senhas não coincidem."); return; }
        if (senha.length < 6)      { setErro("A senha deve ter ao menos 6 caracteres."); return; }

        setLoading(true);
        service.redefinirSenha({ email, codigoVerificacao: codigo, novaSenha: senha })
            .then(() => {
                toast.success("Senha redefinida com sucesso!");
                setTimeout(() => navigate("/login"), 1500);
            })
            .catch((err) => {
                const msg = err.response?.data?.message || "Erro ao redefinir senha.";
                setErro(msg);
                if (msg.includes("Código de verificação inválido")) {
                    setCodigoInvalidado(true);
                    setCodigo("");
                }
            })
            .finally(() => setLoading(false));
    };

    return (
        <AuthShell>
            <AuthLogo />

            <div className="text-center mb-5">
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-success/10 border border-success/20 mb-3">
                    <i className="fa fa-shield-alt text-success text-base" />
                </div>
                <h1 className="font-display text-base font-semibold text-foreground">Redefinir senha</h1>
                <p className="text-xs text-muted-foreground mt-1">
                    Código enviado para <span className="font-medium text-foreground/80">{email}</span>
                </p>
            </div>

            {/* aviso código enviado */}
            <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-success/10 border border-success/20 mb-4">
                <i className="fa fa-check-circle text-success text-sm flex-shrink-0" />
                <p className="text-xs text-success">Verifique sua caixa de entrada e insira o código abaixo.</p>
            </div>

            <form onSubmit={redefinir} className="flex flex-col gap-4">
                <Field label="Código de verificação" icon="fa-hashtag">
                    <input
                        type="text"
                        placeholder="000000"
                        value={codigo}
                        onChange={(e) => setCodigo(e.target.value)}
                        className="auth-input pl-9 tracking-widest font-mono text-center"
                    />
                </Field>

                <Field label="Nova senha" icon="fa-lock" onToggle={() => setShowSenha(v => !v)} show={showSenha}>
                    <input
                        type={showSenha ? "text" : "password"}
                        placeholder="••••••••"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        className="auth-input pl-9 pr-10"
                    />
                </Field>

                <Field label="Confirme a nova senha" icon="fa-lock" onToggle={() => setShowConf(v => !v)} show={showConf}>
                    <input
                        type={showConf ? "text" : "password"}
                        placeholder="••••••••"
                        value={confirmacao}
                        onChange={(e) => setConfirmacao(e.target.value)}
                        className="auth-input pl-9 pr-10"
                    />
                </Field>

                <ErrorMsg msg={erro} />

                {codigoInvalidado ? (
                    <button
                        type="button"
                        onClick={() => navigate("/solicitar-senha")}
                        className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg bg-destructive hover:brightness-95 text-destructive-foreground text-sm font-medium shadow-xs transition-all duration-150"
                    >
                        <i className="fa fa-redo text-sm" />Solicitar novo código
                    </button>
                ) : (
                    <SubmitBtn loading={loading} label="Redefinir senha" icon="fa-check" />
                )}
            </form>

            <BackLink onClick={() => navigate("/login")} />
        </AuthShell>
    );
}


export default RedefinirSenha;

// ─── Componentes compartilhados ───────────────────────────────────────────────
/** Wrapper de página — mesmo card do Login */
function AuthShell({ children }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10">
            <div className="w-full max-w-md bg-card rounded-2xl border border-border p-8 flex flex-col shadow-pop">
                {children}
            </div>
        </div>
    );
}

/** Logo centralizada */
function AuthLogo() {
    return (
        <div className="flex justify-center mb-6">
            <img src={LOGO} alt="Logo Distribuidora York" className="h-10 w-auto object-contain" />
        </div>
    );
}

/**
 * Campo de formulário com ícone à esquerda e, opcionalmente,
 * botão de mostrar/ocultar senha à direita.
 */
function Field({ label, icon, children, onToggle, show }) {
    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-xs font-medium text-muted-foreground">{label}</label>
            <div className="relative">
                <i className={`fa ${icon} absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm pointer-events-none`} />
                {children}
                {onToggle && (
                    <button
                        type="button"
                        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
                        onClick={onToggle}
                        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors duration-150 p-1"
                    >
                        <i className={`fa ${show ? "fa-eye-slash" : "fa-eye"} text-sm`} />
                    </button>
                )}
            </div>
        </div>
    );
}

/** Mensagem de erro padronizada */
function ErrorMsg({ msg }) {
    if (!msg) return null;
    return (
        <div className="flex items-start gap-2.5 px-3 py-2.5 rounded-lg bg-destructive/5 border border-destructive/20">
            <i className="fa fa-exclamation-circle text-destructive text-sm mt-0.5 flex-shrink-0" />
            <p className="text-xs text-destructive leading-snug">{msg}</p>
        </div>
    );
}

/** Botão de submit com estado de loading */
function SubmitBtn({ loading, label, icon }) {
    return (
        <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg bg-primary hover:brightness-95 text-primary-foreground text-sm font-medium shadow-xs transition-all duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
        >
            {loading
                ? <><i className="fa fa-spinner fa-spin text-sm" />Aguarde...</>
                : <><i className={`fa ${icon} text-sm`} />{label}</>
            }
        </button>
    );
}

/** Link "Voltar ao login" */
function BackLink({ onClick, label = "Voltar ao login" }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="mt-5 w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors duration-150 flex items-center justify-center gap-1.5"
        >
            <i className="fa fa-arrow-left text-[10px]" />
            {label}
        </button>
    );
}
